import { InquiryOverviewFilterStyle } from "@components/inquiryOverviewFilter/inquiryOverviewFilterStyle";
import styled from "styled-components";

export const IncidentOverviewFilterStyle = styled(InquiryOverviewFilterStyle)`

`;
